import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getApiDataService } from "../../../services/apiServices";
import { SUB_CATEGORY_API } from "../../../services/CONSTANTS";
import styles from "../ImageUpload.module.css";

function UnitTransactionModal(props) {
  // Initialize state with default values for accountName, accountNo, and status

  // Handler functions for updating account information

  return (
    <Modal isOpen={props.modal} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>
        Unit Transaction By User <strong>{props?.item?.to_user?.name}</strong>{" "}
      </ModalHeader>
      <ModalBody>
        <table className={styles.unitTable}>
          <tr>
            <td colSpan="2">
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <h1 style={{ textAlign: "center" }}>{props?.item?.amount}</h1>{" "}
                <small>{props?.item?.currency}</small>
              </div>
            </td>
          </tr>
          <tr>
            <td className={styles.tl}>Transaction Time</td>
            <td className={styles.tr}>{props?.item?.createdAt}</td>
          </tr>
          <tr>
            <td className={styles.tl}>Transaction Type</td>
            <td className={styles.tr}>{props?.item?.transaction_title?.name}</td>
          </tr>
          <tr>
            <td className={styles.tl}>Transfer from</td>
            <td className={styles.tr}>{props?.item?.from_user?.name}</td>
          </tr>
          <tr>
            <td className={styles.tl}>Transfer to</td>
            <td className={styles.tr}>
              {props?.item?.to_user?.name} ({props?.item?.to_user?.userCode})
            </td>
          </tr>
          <tr>
            <td className={styles.tl}>Amount</td>
            <td className={styles.tr}>
              {props?.item?.amount} {props.item.currency}
            </td>
          </tr>
          <tr>
            <td className={styles.tl}>Notes</td>
            <td className={styles.tr}>{props?.item?.remark}</td>
          </tr>
        </table>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          OK
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default UnitTransactionModal;
